var config = {
  firebase: {
    getApiUrl() {
      return `https://us-central1-fitgames-tw.cloudfunctions.net`
    },
    getImageUrl() {
      return `https://firebasestorage.googleapis.com/v0/b/fitgames-tw.appspot.com/o`
    }
  },
  thirdPartySignIn: {
    facebook: '1358093084392273',
    apple: 'com.appmaster.fitgamesweb',
    line: '1653847132',
    redirectUrl: 'https://fitgames.tw/auth/redirect',
    appleRedirectUrl: 'https://us-central1-fitgames-tw.cloudfunctions.net/user/social/apple',
    lineRedirectUrl: 'https://us-central1-fitgames-tw.cloudfunctions.net/user/social/line'
  },

  log(message) {
    try {
      window.webkit.messageHandlers.logger.postMessage(JSON.stringify(message));
    } catch (err) {
      console.log(JSON.stringify(message));
      console.log(err);
    }
  }

}

export default config
